(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ChannelConfDetailController', ChannelConfDetailController);

    ChannelConfDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'ChannelConf'];

    function ChannelConfDetailController($scope, $rootScope, $stateParams, entity, ChannelConf) {
        var vm = this;
        vm.channelConf = entity;
        vm.load = function (id) {
            ChannelConf.get({id: id}, function(result) {
                vm.channelConf = result;
            });
        };
        var unsubscribe = $rootScope.$on('wamasysApp:channelConfUpdate', function(event, result) {
            vm.channelConf = result;
        });
        
        
        $scope.$on('$destroy', unsubscribe);

    }
})();
